const reconnectTimeLimit = 1000

// 获取cookie的方法：
function getCookie(c_name) {
  if (document.cookie.length > 0) {
    let c_start = document.cookie.indexOf(`${c_name}=`)
    if (c_start != -1) {
      c_start = c_start + c_name.length + 1
      let c_end = document.cookie.indexOf(';', c_start)
      if (c_end == -1) {
        c_end = document.cookie.length
      }
      return decodeURIComponent(document.cookie.substring(c_start, c_end))
    }
  }
  return ''
}
const token = getCookie(process.env.REACT_APP_TOKEN)

const getUrl = (_url) => {
  return `${window.location.protocol === 'https:' ? 'wss://' : 'ws://'}${_url}?token=${token}&group=1`
}

export class Ws {
  parent = {}

  constructor({ url, onOpen, onClose, socketReceiveMsg }) {
    this.url = getUrl(url)
    this.parent.onOpen = onOpen
    this.parent.onClose = onClose
    this.parent.socketReceiveMsg = socketReceiveMsg
    this.ws = new WebSocket(this.url)
  }

  heartCheck = {
    timeout: 1000 * 25, // 25秒发一次心跳
    serverTimeout: 1000 * 2, // 多久内未收到消息自动重连
    reconnectTimeout: reconnectTimeLimit, // 重连尝试间隔
    timeoutObj: null,
    serverTimeoutObj: null,
    reconnectTimeoutObj: null,
    reset() {
      clearTimeout(this.timeoutObj)
      clearTimeout(this.serverTimeoutObj)
      this.reconnectTimeout = reconnectTimeLimit
      return this
    },
    start: () => {
      this.heartCheck.timeoutObj = setTimeout(() => {
        try {
          // 这里发送一个心跳，后端收到后，返回一个心跳消息，
          // onmessage拿到返回的心跳就说明连接正常
          this.ws.send('ping')
          this.heartCheck.serverTimeoutObj = setTimeout(() => {
            // 如果超过一定时间还没重置，说明后端主动断开了
            this.ws.close() // close后会延迟数十秒触发onClose, 必须手动重连
            this.reconnect()
          }, this.heartCheck.serverTimeout)
        } catch (error) {
          // console.log(error, 'error');
        }
      }, this.heartCheck.timeout)
    },
  }

  init() {
    if (this.ws) {
      this.ws.onclose = this.onClose
      this.ws.onerror = this.onError
      this.ws.onopen = this.onOpen
      this.ws.onmessage = this.onMessage
    }
  }

  unmount() {
    if (this.ws) {
      this.ws.close()
      this.ws.onmessage = null
      this.ws.onclose = null
      this.ws.onerror = null
      this.ws.onopen = null
      this.ws = null
      this.heartCheck.reset()
    }
  }

  onClose() {
    if (this.ws) {
      this.ws.close()
    }
  }

  onOpen = (e) => {
    this.parent?.onOpen?.(e, this)
    console.log(
      '%cws open',
      'color: #0f0;background-color: #000;padding: 0 4px',
    )
    this.heartCheck.reset().start() // 心跳检测重置
  }

  onMessage = (e) => {
    if (e.data === 'pong') this.heartCheck.reset().start()
    this.parent.socketReceiveMsg?.(e)
  }

  onError = () => {
    console.log(
      '%cws error',
      'color: #f00;background-color: #000;padding: 0 4px',
    )
    this.reconnect()
  }

  send(data) {
    if (this.ws?.readyState === WebSocket.OPEN) {
      this.ws.send(data)
      this.heartCheck.reset().start() // 心跳检测重置
    } else {
      console.log('ws连接已断开 无法操作')
    }
  }

  reconnect = () => {
    if (!this.ws || !localStorage.getItem('token')) return
    clearTimeout(this.heartCheck.reconnectTimeoutObj)
    this.heartCheck.reconnectTimeoutObj = setTimeout(() => {
      this.ws = null
      // 没连接上会一直重连, 重连时间间隔每次会翻倍, 300s封顶
      this.createWebSocket()
      this.heartCheck.reconnectTimeout = Math.min(
        this.heartCheck.reconnectTimeout * 2,
        300 * 1000,
      )
    }, this.heartCheck.reconnectTimeout)
  }
}
